module.exports = __webpack_public_path__ + "img/ai_audio_text_loading.2d60b68.png";